"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var user_store_1 = require("../reverb-js-common/user_store");
var I18n = require("i18n-js");
var elog_1 = require("@reverbdotcom/commons/dist/elog");
var reverb_cookie_1 = require("./reverb_cookie");
var set_ajax_meta_tags_1 = require("./set_ajax_meta_tags");
var lodash_1 = require("lodash");
/**
 * DEPRECATED
 *
 * Please consider using the CoreClient or RQL to fetch data from the API.
 * This AJAX client is jQuery based, which means it returns a Promise "like"
 * repsonse that uses the functions `done()` and `fail()` to register success
 * and failure callbacks.
 *
 * WILL NOT WORK WITH async/await
 */
var defaultHeaders = {};
function setDefaultHeader(header, value) {
    defaultHeaders[header] = value;
    return defaultHeaders;
}
exports.setDefaultHeader = setDefaultHeader;
var oauthToken = reverb_cookie_1.default.get('reverb_user_oauth_token');
setOAuthToken(oauthToken);
function setOAuthToken(token) {
    if (!token) {
        return;
    }
    setDefaultHeader('Authorization', "Bearer " + token);
}
exports.setOAuthToken = setOAuthToken;
function request(url, data, options, version, type) {
    if (data === void 0) { data = {}; }
    if (options === void 0) { options = { headers: {} }; }
    var defaultOptions = {
        url: url,
        type: type,
        data: data,
        headers: defaultHeaders,
    };
    var headers = lodash_1.pickBy(tslib_1.__assign(tslib_1.__assign({ 'Accept-Version': version, 'X-Item-Region': reverb_cookie_1.default.get('itemRegionOverride'), 'X-Display-Currency': user_store_1.default.getState().currency, 'X-Shipping-Region': user_store_1.default.getState().shippingRegionCode, 'Accept-Language': I18n.locale, 'X-CSRF-Token': set_ajax_meta_tags_1.csrfToken(), 'X-Context-Id': user_store_1.default.getState().cookieId, 'X-Session-Id': elog_1.currentSession().ID(), 'X-Requested-With': 'XMLHttpRequest', 'X-Reverb-App': 'REVERB' }, defaultHeaders), options.headers), lodash_1.identity);
    var ajaxOptions = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, defaultOptions), options), { headers: headers });
    return $.ajax(ajaxOptions);
}
function get(url, data, options, version) {
    return request(url, data, options, version, 'GET');
}
exports.get = get;
function post(url, data, options, version) {
    return request(url, data, options, version, 'POST');
}
exports.post = post;
function put(url, data, options, version) {
    return request(url, data, options, version, 'PUT');
}
exports.put = put;
function destroy(url, data, options, version) {
    return request(url, data, options, version, 'DELETE');
}
exports.destroy = destroy;
var V3_VERSION = '3.0';
exports.V3 = {
    get: function (url, data, options) {
        if (data === void 0) { data = {}; }
        if (options === void 0) { options = {}; }
        return get(url, data, options, V3_VERSION);
    },
    post: function (url, data, options) {
        if (data === void 0) { data = {}; }
        if (options === void 0) { options = {}; }
        return post(url, data, options, V3_VERSION);
    },
    postJSON: function (url, data, options) {
        if (data === void 0) { data = {}; }
        if (options === void 0) { options = {}; }
        var postOptions = tslib_1.__assign({ contentType: 'application/json' }, options);
        return post(url, JSON.stringify(data), postOptions, V3_VERSION);
    },
    put: function (url, data, options) {
        if (data === void 0) { data = {}; }
        if (options === void 0) { options = {}; }
        return put(url, data, options, V3_VERSION);
    },
    destroy: function (url, data, options) {
        if (data === void 0) { data = {}; }
        if (options === void 0) { options = {}; }
        return destroy(url, data, options, V3_VERSION);
    },
};
exports.default = {
    get: get,
    post: post,
    put: put,
    destroy: destroy,
    setDefaultHeader: setDefaultHeader,
    setOAuthToken: setOAuthToken,
    V3: exports.V3,
};
//# sourceMappingURL=api_request.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/api_request.js
// module id = 7wpV
// module chunks = 20 21